import styled from 'styled-components';

import media from 'apps/auth/theme/media';

interface ContainerProps {
    hasBottomPanel?: boolean;
}

const shouldForwardContainerProp = (prop: string) => !['hasBottomPanel'].includes(prop);

export const Container = styled.div.withConfig({ shouldForwardProp: shouldForwardContainerProp })<ContainerProps>`
    padding: ${(props) => (props.hasBottomPanel ? '72px 24px 128px 24px' : '72px 24px 48px 24px')};
    margin: 0 auto;
    /* content width 480 */
    max-width: 528px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1;

    ${media.tablet720} {
        padding: 128px 24px;
        /* content width 504px */
        max-width: 552px;
    }

    & > form {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
`;
